
  export const style={
    inpuStyle:{
      colorInput:"#74B5C2"
    },
    url:{
      urlClient:"https://bhava.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_bhava.png",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: true,
       autoRegister: false,
       recaptchaVersion : "V2"
    },
    CurrencyName:{
      name:"Flow/Flows"
    },
    teamName:{
      name:"Bhava"
    },
    hasToken: true,
    hostHeader: "bhava"
  }
